import { Image as AntImage, ImageProps } from 'antd';

type TImageProps = ImageProps;
export const ImageGroup = AntImage.PreviewGroup;

const Image = ({ src, alt, ...props }: TImageProps) => {
  return <AntImage src={src ?? '/images/thumb.jpg'} alt={alt ?? 'image'} {...props} />;
};

export default Image;
